import React, {useState} from 'react';
import s from './BonusesTable.module.css';
import LightGreenButton from '../../../../Components/Buttons/LightGreenButton';
import {RequestPaymentListType} from '../../../../types/TypesUserOrders';
import {useGetPaymentListQuery} from '../../../../redux/DepotSlice/depotCashierApi';
import {useTranslation} from 'react-i18next';
import PreLoaderComponent from '../../../../assets/Animations/PreLoaderComponent/PreLoaderComponent';
import GridTableHead from '../../../../Components/GridTableHead/GridTableHead';
import TableRowElement from './TableRowElement';
import {dateFormatter} from '../../../../assets/utils/dateUtils';

const BonusesTable = () => {
	const {t} = useTranslation();
	const now = new Date();
	// +1 день
	const plusOneDay = new Date(now);
	plusOneDay.setDate(now.getDate() + 1);
	// -3 месяца
	const minusThreeMonths = new Date(now);
	minusThreeMonths.setMonth(now.getMonth() - 3);

	const [filters] = useState<RequestPaymentListType>({
		from_date: dateFormatter(minusThreeMonths),
		to_date: dateFormatter(plusOneDay),
		client_name: '',
	});
	const {data: paymentList, isLoading} = useGetPaymentListQuery(filters);
	
	// Состояние для пагинации
	const [visibleCount, setVisibleCount] = useState(10);
	
	// Получаем видимые платежи
	const visiblePayments = paymentList?.payments?.slice(0, visibleCount) || [];

	return (
		<div className={s.tableContainer}>
			{isLoading ? (
				<PreLoaderComponent type={'image'} size={'big'} />
			) : (
				<>
					{paymentList && paymentList?.payments?.length > 0 ? (
						<>
							<div className={s.tableTitle}>
								{t('Список видаткових ордерів')}
							</div>
							{/* Обгортка для адаптивного горизонтального скролу */}
							<div className={s.tableWrapper}>
								<div className={s.tableGrid}>
									<GridTableHead
										columns={[
											'Дата',
											'Контракт',
											"Ім'я",
											'сума',
											'Вид транзакції',
											'Дія',
										]}
										gridTemplateColumns="repeat(6, 1fr)"
										customClassName={s.tableRow}
									/>
									{visiblePayments.map((payment) => (
										<TableRowElement payment={payment} key={payment.id} />
									))}
									{paymentList.payments.length > visibleCount && (
										<div className={s.buttonWrapper}>
											<LightGreenButton
												text={t('дивитись більше')}
												type={'button'}
												onClick={() => setVisibleCount((prev) => prev + 10)}
											/>
										</div>
									)}
								</div>
							</div>
						</>
					) : null}
				</>
			)}
		</div>
	);
};

export default BonusesTable;
